import React from "react";
import { graphql, useStaticQuery } from "gatsby";

import PageWrapper from "@modules/Layout/PageWrapper";
import HeadSeo from "@modules/seo/components/HeadSeo";
import Resource from "@modules/Resource/components";
import { ResourceFilterContext } from "@modules/Resource/context";

import "@graphql/seoFragments";
import "@graphql/shared/bannerFragment";
import "@graphql/resourceItemFragment";
import { ResourcePage as ResourcePageType } from "@types/resource";
import { ResourceItem } from "@types/support";

interface IProps {
  path: string;
  location: any;
}

interface ResourcePageQueryData {
  strapiResourcePage: ResourcePageType;
  allStrapiResource: {
    nodes: ResourceItem[];
  };
}

const ResourcePage: React.FC<IProps> = props => {
  const { location } = props;
  const query = new URLSearchParams(location.search);
  let type = query.get("type") || "all";

  const data = useStaticQuery<ResourcePageQueryData>(graphql`
    query {
      strapiResourcePage {
        id
        banner {
          ...BannerFields
        }
        seo {
          ...SeoFields
        }
        about_title
        cards {
          ...IconWithContentCardFields
        }
      }
      allStrapiResource(sort: { createdAt: DESC }, limit: 1000) {
        totalCount
        nodes {
          ...ResourceItemFields
        }
      }
    }
  `);

  const { metaTitle, metaDescription, keywords, meta_image } =
    data.strapiResourcePage.seo;

  const resources = data.allStrapiResource.nodes;

  return (
    <PageWrapper>
      <HeadSeo
        title={metaTitle}
        description={metaDescription}
        pathname={location.pathname}
        keywords={keywords}
        image={meta_image.formats.small.url}
      />
      <ResourceFilterContext.Provider value={type}>
        <Resource resources={resources} data={data.strapiResourcePage} />
      </ResourceFilterContext.Provider>
    </PageWrapper>
  );
};

export default ResourcePage;
